'use client';

import { SelectButton, useEventBus } from '@hc-frontend/core-ui';
import type { MouseEventHandler } from 'react';

import type { SendMetricEvent, SendMetricEventTarget } from '../../atoms';
import type { SelectButtonWithTrackingProps } from './select-button-with-tracking.types';

export function SelectButtonWithTracking({
  name,
  metricTags,
  onClick,
  isPending,
  ...props
}: SelectButtonWithTrackingProps & { isPending: boolean }) {
  const eventBus = useEventBus();

  const handleClick: MouseEventHandler<HTMLInputElement> = (event) => {
    const idToSend = event.currentTarget.value;
    const additionalMetricTags = {
      click_action: idToSend,
      ...metricTags,
    };

    eventBus.publish<SendMetricEvent, SendMetricEventTarget>({
      id: name,
      topic: 'metric.client.message',
      source: event.currentTarget,
      metric: {
        name: 'click',
        tags: additionalMetricTags,
      },
    });
    onClick?.(event);
  };

  return (
    <SelectButton
      {...props}
      name={name}
      onClick={handleClick}
      disabled={isPending}
    />
  );
}
